import React, {Fragment, useState} from 'react';
import Button from "../../../Button";
import TextInput from '../../../TextInput';
import Modal from "../../../../layout/Modal";
import Portal from "../../../../layout/Portal";
import isEqual from "lodash-es/isEqual";
import {set, get, unset} from '../../../../../utils/dotutils';
import Select from "../../../Select";
import CheckBox from "../../../CheckBox";
import {optionsTemplate} from "../../../../../utils/formatters";
import {Transforms} from "slate";
import {ReactEditor} from "slate-react";
import FigureEditor from "../../../../editors/figureEditor";
import {ChildFragmentEditor} from "../../../../editors/FragmentEditor";
import ComponentRule from "../../slate/booq/ComponentRule";
import {DeserializedElementRule} from "../../slate/Transformation";

class FigureNode extends React.Component<any, any> {

    constructor(props){
        super(props);
        this.state = {
            editing: false,
            toolbarPos: 'top',
            values: JSON.parse(JSON.stringify(props.element.props)),
            editvalues: JSON.parse(JSON.stringify(props.element.props))
        };
    }

    setData = (data) => {
        const path = ReactEditor.findPath(this.props.editor, this.props.element);
        Transforms.setNodes(this.props.editor, {props: {...data}}, {
            at: path,
        });
        this.setState({values: data, editvalues: data}, () => this.imgNode.focus());
    }

    setSelected = (e) => {
        e && e.preventDefault();
        const toolbarPos = this.imgNode.offsetTop - this.imgNode.closest(".rt-editor-input").scrollTop > 100 ? 'top' : 'bottom';
        this.setState({toolbarPos});
    }

    clearSelected = (e) => {
        e && e.preventDefault();
    }

    openEditor = (e) => {
        e && e.preventDefault();
        this.setState({editing: true});
    }

    onModalChange = (field, value) => {
        const editvalues = JSON.parse(JSON.stringify({...this.state.editvalues}));
        set(editvalues, "presetdata." + field, value);
        this.setState({editvalues});
    }

    setAlignAndSize = (align, imgstyle) => {
        this.setData({
            ...this.state.values,
            presetdata: {
                ...this.state.values.presetdata,
                align,
                imgstyle
            }
        })
    }

    render() {
        const data = this.state.values?.presetdata || {};
        const editdata = this.state.editvalues?.presetdata || {};
        const {imgstyle, align, caption} = data;
        const figure_id = this.state.values?.id;
        const src = "index.php?option=figure&figure_id=" + figure_id + "&imgstyle=" + imgstyle + "&resptype=file";

        const actionButtons = [
            {
                text: "Ok",
                props: {color: "primary", className: "pull-right", disabled: isEqual(this.state.values, this.state.editvalues)},
                onClick: async () => {
                    this.setData(this.state.editvalues);
                    this.setState({editing: false});
                }
            }, {
                text: "Mégse",
                props: {color: "default"},
                className: "pull-right",
                onClose: true,
                onClick: async () => {
                    this.setState({editing:false, editvalues: JSON.parse(JSON.stringify(this.state.values))});
                }
            }
        ];
        if (editdata.linktype) {
            actionButtons.push(
                {
                    text: "Link törlése",
                    props: {color: "danger"},
                    className: "pull-left",
                    onClose: true,
                    onClick: async () => {
                        const editvalues = JSON.parse(JSON.stringify({...this.state.editvalues}));
                        unset(editvalues, "presetdata.linktype");
                        unset(editvalues, "presetdata.linkvalue");
                        this.setState({editvalues});
                    }
                }
            );
        }

        return <Fragment>
            <Portal>
                <Modal
                    state={this.state.editing ? "on" : "off"}
                    size="medium"
                    header={"Kép szerkesztése"}
                    buttons={actionButtons}>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <TextInput
                                name="caption"
                                value={editdata.caption}
                                saveChanges={this.onModalChange}
                                label="Képfelirat"
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <Select
                                name="linktype"
                                objectValue={false}
                                optionname="linktype"
                                storeType="local"
                                saveChanges={this.onModalChange}
                                value={editdata.linktype}
                                label="Link típusa"
                            />
                        </div>
                    </div>
                    {!!editdata.linktype && <div className="row form-row">
                        <div className="col-md-12">
                            {editdata.linktype && editdata.linktype !== "url"
                                ?
                                    <Select
                                        name="linkvalue"
                                        objectValue={false}
                                        component={editdata.linktype}
                                        optionsTemplate={optionsTemplate(editdata.linktype)}
                                        saveChanges={this.onModalChange}
                                        storeType="remote"
                                        value={editdata.linkvalue}
                                        label="Link tárgya"
                                    />
                                :
                                <TextInput name="linkvalue" value={editdata.linkvalue || ''} saveChanges={(field, value) => this.onModalChange(field, value.trim())} label="Url" />
                            }
                        </div>
                    </div>}
                    <div className="row form-row">
                        <div className="col-md-12">
                            <CheckBox
                                name="linktarget"
                                saveChanges={this.onModalChange}
                                value={editdata.linktarget || '_blank'}
                                checked={!!editdata.linktarget}
                                label="Megnyitás új ablakban"
                            />
                        </div>
                    </div>
                </Modal>
            </Portal>
            <figure {...this.props.attributes} contentEditable={false} ref={(node)=> {this.imgNode = node; this.props.attributes.ref(node)}} className={"image " + imgstyle + " align-" + align} tabIndex={-1} onMouseDown={this.setSelected} onFocus={this.setSelected} onBlur={this.clearSelected}>
                {this.props.children}
                <div className={"image-tools image-tools-" + this.state.toolbarPos + " btn-toolbar"} contentEditable={false}>
                    <Button
                        onClick={()=>this.setAlignAndSize('left', 'post_side')}
                        icon="align-left"
                        tooltip="Balra rendezés"
                        disabled={align==='left'}
                        color={align==='left' ? "primary" : "default"}
                    />
                    <Button
                        onClick={()=>this.setAlignAndSize('center','post_side')}
                        icon="align-center"
                        tooltip="Középre rendezés"
                        disabled={align==='center'&&imgstyle!=='post_full'}
                        color={align==='center'&&imgstyle!=='post_full' ? "primary" : "default"}
                    />
                    <Button
                        onClick={()=>this.setAlignAndSize('right', 'post_side')}
                        icon="align-right"
                        tooltip="Jobbra rendezés"
                        disabled={align==='right'}
                        color={align==='right' ? "primary" : "default"}
                    />
                    <Button
                        onClick={()=>this.setAlignAndSize('center', 'post_full')}
                        icon="align-justify"
                        tooltip="Teljes szélesség"
                        disabled={imgstyle==='post_full'}
                        color={imgstyle==='post_full' ? "primary" : "default"}
                    />
                    <Button
                        onClick={this.openEditor}
                        icon="edit"
                        tooltip="Szerkesztés"
                        color="default"
                    />
                    <Button
                        onClick={this.props.remove}
                        icon="delete"
                        tooltip="Törlés"
                        color="default"
                    />
                </div>
                <img src={src} alt="" />
                {caption ? <div className="image-caption">{caption}</div> : ""}
            </figure>
        </Fragment>;
    }
}

const toolbarButton = (props) => {
    const [opened, setOpened] = useState(false);
    return <Fragment>
        <Button
            disabled={!(props.component && props.componentId) || props.disabled}
            tooltip="Kép beszúrás"
            icon="image"
            color={opened ? "primary" : "default"}
            onClick={() => setOpened(!opened)}
        />
        {opened && <Portal portalId={props.toolbarContainerId}>
            <FigureEditor
                component={props.component}
                componentId={props.componentId}
                list={ChildFragmentEditor}
                editor={() => null}
                selection={null}
                values={{}}
                loadForm={(img: {
                    figure_id: number | null | string,
                    linktype: string,
                    linkvalue: string,
                    orientation: string,
                }) => {
                    const data: {
                        linktype: string,
                        linkvalue: string,
                        imgstyle: string,
                        align: string
                    } = {};
                    if (img.linktype) {
                        data.linktype = img.linktype;
                        data.linkvalue = img.linkvalue;
                    }
                    if (img.orientation === "landscape") {
                        data.imgstyle = "post_full";
                        data.align = "center";
                    } else {
                        data.imgstyle = "post_side";
                        data.align = "left";
                    }
                    props.insert({
                        type: 'component',
                        props: {
                            props: {
                                type: 'figure',
                                presetdata: data,
                                id: img.figure_id
                            }
                        }
                    });
                }}
                isLoading={props.disabled}
                pageSize={0}
            />
        </Portal>}
    </Fragment>
}

export default FigureNode;

export const Rules: {[key: string]: DeserializedElementRule<HTMLElement>} = {
    "figure": ComponentRule({
        type: 'figure',
        render: FigureNode,
        toolbarButton
    })
}